export default __webpack_public_path__ + "static/media/phone.c233b324.2190cd94.svg";